import './App.css';
import 'aos/dist/aos.css';
import {useQueryClient} from '@tanstack/react-query';
import Aos from 'aos';
import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Route, Routes} from 'react-router-dom';

import ProtectedRoute from './commonComponents/ProtectedRoute/ProtectedRoute';
import AdminProtectedRoute from './commonComponents/ProtectedRoutes/ProtectedRoute';
import {ResetPasswordComponent} from './components/ResetPasswordComponent';
import JsonData from './data/data.json';
import {loadCartFromStorage} from './redux/authAction';
import {selectAuth} from './redux/selectors';
import {AboutUsScreen} from './screenComponent/AboutUsScreen';
import {AdminDashboard} from './screenComponent/AdminDashboard';
import BrandCenter from './screenComponent/BrandCenter/BrandCenter';
import {BusinessCard} from './screenComponent/BusinessCard';
import {CartScreen} from './screenComponent/CartScreen';
import {CheckOutScreen} from './screenComponent/CheckOutScreen';
import ContactUsForm from './screenComponent/ContactUsComponent/ContactUsForm';
import {HelpCenter} from './screenComponent/HelpCenter';
import {HomeScreen} from './screenComponent/HomeScreen';
import {LayoutComponent} from './screenComponent/LayoutComponent';
import {LoginScreen} from './screenComponent/LoginScreen';
import {RegistrationScreen} from './screenComponent/LoginScreen/RegistrationScreen';
import PrivacyAndPolicy from './screenComponent/PrivacyAndPolicy/PrivacyAndPolicy';
import {ProductDetails} from './screenComponent/ProductDetails';
import {ProductScreen} from './screenComponent/ProductScreen';
import {ScrollToTop} from './screenComponent/ScrollToTop';
import {TermsAndCondition} from './screenComponent/TermsAndCondition';
import {UserHistory} from './screenComponent/UserHistory';

const App = () => {
  const dispatch = useDispatch();
  const auth = useSelector(selectAuth);

  const queryClient = useQueryClient();

  queryClient.invalidateQueries(['products-by-ids']);

  useEffect(() => {
    if (auth?.user?.id) {
      console.log('AUTH USER ID:', auth.user.id);
      dispatch(loadCartFromStorage(auth.user.id));
    }
  }, [auth?.user?.id, dispatch]);

  useEffect(() => {
    Aos.init({
      duration: 1000,
      easing: 'ease-out-cubic',
      offset: 120,
    });
  }, []);

  useEffect(() => {
    Aos.refresh();
  }, [location]);

  return (
    <div>
      <ScrollToTop />
      <Routes>

        <Route path={'/'}>
          <Route path={'login'} element={<LoginScreen />} />
          <Route path={'register'} element={<RegistrationScreen />} />
          <Route path={'forgot-password'} element={<ResetPasswordComponent />} />

          <Route path={'businesscard'} element={<BusinessCard />} />
        </Route>

        <Route path={'/'} element={<LayoutComponent />}>
          <Route index element={<HomeScreen />} />
          <Route path={'product'} element={<ProductScreen />} />
          <Route path={'about'} element={<AboutUsScreen />} />
          <Route path={'brand-center'} element={<BrandCenter />} />
          <Route path={'contact'} element={<ContactUsForm />} />
          <Route path={'product/:id'} element={<ProductDetails />} />
          <Route path={'terms'} element={<TermsAndCondition data={JsonData.TermsAndConditions} />} />
          <Route path={'privacy'} element={<PrivacyAndPolicy data={JsonData.TermsAndConditions} />} />  
          <Route path={'help'} element={<HelpCenter />} />

          <Route path={'cart'} element={(
            <ProtectedRoute>
              <CartScreen />
            </ProtectedRoute>      
          )} />

          <Route path={'checkout'} element={(
            <ProtectedRoute>
              <CheckOutScreen />
            </ProtectedRoute>
          )} />

          <Route path={'userhistory'} element={(
            <ProtectedRoute>
              <UserHistory />
            </ProtectedRoute>
          )} />

        </Route>
        <Route element={<AdminProtectedRoute />}>
          <Route path={'/admin/*'} element={<AdminDashboard />} />
        </Route>
      </Routes>
      <ScrollToTop />

    </div>
  );
};

export default App;
